import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 18l9 -6.462l-9 -5.538v12h18v-12l-9 5.538","key":"svg-0"}]]

const IconBrandCampaignmonitor = createReactComponent('outline', 'brand-campaignmonitor', 'BrandCampaignmonitor', __iconNode);

export default IconBrandCampaignmonitor;